/**
 * The person put their sandbox to sleep in this tab (SandboxService sleepSandbox). Until they wake it (Wake up,
 * wakeSandbox) or go to a page that uses the sandbox (a project, Projects, Chat: noteSandboxPage), the web app's GETs
 * to the sandbox say `x-flow-no-wake`, and the gateway answers them asleep (503 code asleep) instead of waking it:
 * the background polls (the Activity badge, the inbox, the overview) never wake a sandbox put to sleep.
 */
import { isSandboxRequest } from './sandboxPending';

let slept = false;
// The gateway answers 202 before the pod is gone, so for a moment its state still says running: that is the sleep
// settling, not someone waking it elsewhere.
const SETTLE_MS = 60_000;
let sleptAt = 0;
let seenNotRunning = false;

// The pages that keep it asleep: Home (the sandbox's own page) and Settings.
const RESTFUL_PAGES = new Set(['/', '/sandbox', '/settings']);

export const sandboxSleptByChoice = () => slept;
export const markSleptByChoice = () => { slept = true; sleptAt = Date.now(); seenNotRunning = false; };
export const resetSleptByChoice = () => { slept = false; sleptAt = 0; seenNotRunning = false; };

/** The sandbox was just put to sleep and has not yet been seen going down: a "running" answer now is not a wake. */
export function sleepIsSettling(now = Date.now()) {
  return slept && !seenNotRunning && now - sleptAt < SETTLE_MS;
}
/** The state read while it sleeps by choice: once it was seen not running, a later "running" is a real wake. */
export function noteStateWhileSleeping(state) {
  if (slept && state !== 'running') { seenNotRunning = true; }
}

/** A page the person opened: one that uses the sandbox ends the sleep (the next request wakes it, as always). */
export function noteSandboxPage(pathname) {
  if (slept && !RESTFUL_PAGES.has(String(pathname || '/').replace(/\/+$/, '') || '/')) { resetSleptByChoice(); }
}

/** Whether this request goes out with `x-flow-no-wake`: a GET to the sandbox while it sleeps by the person's choice. */
export function noWake(input, init = {}) {
  if (!slept) { return false; }
  const method = String(init.method || (typeof input === 'object' && input?.method) || 'GET').toUpperCase();
  return (method === 'GET' || method === 'HEAD') && isSandboxRequest(input);
}
